const data = {
  "testimoni" : [
    {
      "id": 1,
      "name": "Edwin O'Connor",
      "star": 5,
      "img": "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
      "review": "Menggunakan platform UmahBali untuk pencarian properti sangat terbantu karena tidak selalu harus mendatangi setiap perumahan atau menghadiri pameran properti offline, apalagi di kala pandemi saat ini."
    },
    {
      "id": 2,
      "name":"Summer Young",
      "star": 5,
      "img": "https://images.unsplash.com/photo-1635839090719-72082060a39e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=387&q=80",
      "review":"Sekarang mencari properti, entah itu rumah, kantor, ruko, vila untuk disewa ataupun dibeli jadi lebih mudah banget gara-gara situs pencari properti UmahBali ini. Apalagi untuk pengguna smartphone juga bisa akses situs ini dengan mudah karena sudah mobile friendly."
    },
    {
      "id": 3,
      "name": "Miles Scott",
      "star": 5,
      "img": "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzF8fHBvcnRyYWl0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      "review": "Akses di UmahBali sangat mudah dibandingkan dengan website online properti lainnya, ketika melakukan filter langsung mendapatkan pilihan properti lokasi yang sesuai dan budget yang diinginkan"
    },
    {
      "id": 4,
      "name": "Agnes Gray",
      "star": 5,
      "img": "https://images.unsplash.com/photo-1581403341630-a6e0b9d2d257?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NzF8fHBvcnRyYWl0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      "review": "UmahBali termasuk website yang simple juga menyediakan fitur menghubungi langsung agen properti melalui email atau nomor yang disediakan"
    }
  ]
}

export default data;